export default {
  title: {
    changePassword: 'Change Password'
  },
  label: {
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password'
  },
  message: {
    passwordNotSame: 'Please make sure the two passwords are the same.',
    passwordSameAsPrevious: 'Your new password must be different from the previous one',
    updateSuccess: 'Your password has been updated successfully.'
  }
}
